// src/hooks/useGlobalHotkeys.ts
import { useEffect } from "react";
import { CueNote } from "../types";

export function useNumberHotkeys(notesRef: React.MutableRefObject<CueNote[]>, setActiveNoteId: (id: string) => void) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const tag = (document.activeElement?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea") return;
      if (!notesRef.current.length) return;

      const num = parseInt(e.key, 10);
      if (num >= 1 && num <= 9) {
        const idx = num - 1;
        const note = notesRef.current[idx];
        if (note) {
          setActiveNoteId(note.id);
          const el = document.getElementById(`cueboard-title-${note.id}`);
          if (el) {
            el.classList.add("highlight-flash");
            setTimeout(() => el.classList.remove("highlight-flash"), 600);
          }
        }
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [notesRef, setActiveNoteId]);
}

export function useReshareHotkey(enabledRef: React.MutableRefObject<boolean>, getLastHeardAgoSec: () => number | null, onReshare: () => void, devForce?: () => void) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const tag = (document.activeElement?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea") return;

      // Quick re-share (R) based on INTENT (enabledRef), not volatile stream state
      if (e.key.toLowerCase() === "r" && enabledRef.current) {
        const lastHeard = getLastHeardAgoSec();
        if (lastHeard !== null && lastHeard >= 7) {
          e.preventDefault();
          onReshare();
          return;
        }
      }

      // Optional dev hook passed by caller (e.g., Ctrl+Alt+R)
      if (devForce && e.ctrlKey && e.altKey && e.key.toLowerCase() === "r") {
        e.preventDefault();
        devForce();
      }
    }

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [enabledRef, getLastHeardAgoSec, onReshare, devForce]);
}
